import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { slideOutUp, slideInUp } from 'ng-animate';
import { trigger, transition, useAnimation } from '@angular/animations';
import { ActiveCall } from 'app/models/dto/call.model';
import { PhoneLocaleService } from '../../../services/phone-locale.service';

@Component({
  selector: 'app-on-hold-call',
  templateUrl: './on-hold-call.component.html',
  styleUrls: ['./on-hold-call.component.scss'],
  animations: [
    trigger('animateIn', [
      transition(':enter', useAnimation(slideInUp, {params: {timing: 0.3}}))
    ]),
    trigger('animateOut', [
      transition(':leave', useAnimation(slideOutUp, {params: {timing: 0.2}}))
    ]),
  ],
  standalone: false
})
export class OnHoldCallComponent implements OnInit, OnChanges {

  @Input() secondaryCall: ActiveCall;
  @Input() callStateIsProcessing: boolean;
  @Output() swapTheCalls = new EventEmitter();
  @Output() mergeTheCalls = new EventEmitter();

  currentOnHoldCallDisplay = false;
  disableSwitchCallsButton = false;

  secondaryCallCountryCode = '';
  displayPhoneNumber = '';

  constructor(private phoneLocaleService: PhoneLocaleService) {
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.toggleOnHoldCallBar(changes);
    this.getDisplayPhoneNumber(changes);
  }

  toggleOnHoldCallBar(changes: SimpleChanges): void {
    if (changes.secondaryCall) {
      this.currentOnHoldCallDisplay = !!this.secondaryCall ? true : false;
    }
  }

  getDisplayPhoneNumber(changes: SimpleChanges): void {
    if (changes.secondaryCall) {
      this.displayPhoneNumber = this.phoneLocaleService.getPhoneNumberFromActiveCall(this.secondaryCall, false);
    }
  }

  mergeCalls() {
    this.mergeTheCalls.emit();
  }

  swapCalls() {
    this.swapTheCalls.emit();
  }

}
